import { requestData } from "@/api/request";
import { DeleteRequest, PageResult } from "@/types/common";
import {
  NotificationQueryRequest,
  NotificationReadRequest,
  NotificationSendSysRequest,
  NotificationUnreadVO,
  NotificationVO,
} from "@/types/notification";

export function listNotifications(data: NotificationQueryRequest) {
  return requestData<PageResult<NotificationVO>>({
    url: "/notification/list/page/vo",
    method: "POST",
    data,
  });
}

export function getNotificationUnreadCount() {
  return requestData<NotificationUnreadVO>({
    url: "/notification/unread/count",
    method: "GET",
  });
}

export function readNotification(data: NotificationReadRequest) {
  return requestData<boolean>({
    url: "/notification/read",
    method: "POST",
    data,
  });
}

export function readBatchNotification(data: NotificationReadRequest) {
  return requestData<boolean>({
    url: "/notification/read/batch",
    method: "POST",
    data,
  });
}

export function readAllNotification(data?: NotificationReadRequest) {
  return requestData<boolean>({
    url: "/notification/read/all",
    method: "POST",
    data,
  });
}

export function deleteNotification(data: DeleteRequest) {
  return requestData<boolean>({
    url: "/notification/delete",
    method: "POST",
    data,
  });
}

export function deleteBatchNotification(data: NotificationReadRequest) {
  return requestData<boolean>({
    url: "/notification/delete/batch",
    method: "POST",
    data,
  });
}

export function sendSystemNotification(data: NotificationSendSysRequest) {
  return requestData<boolean>({
    url: "/notification/system/send",
    method: "POST",
    data,
  });
}
